/**
 * <EditorialText>
 * Canonical editorial paragraph for LATIR.
 * Matches the Home intro style exactly (see /pages/Home.jsx ~line 35).
 * Use it for every descriptive/introductory text across the site so the
 * museum feels typographically unified.
 *
 * Underlying CSS class: `.editorial-copy` (defined in /src/index.css).
 * Aliases kept for backwards compatibility: .program-intro, .page-intro,
 * .section-description — all resolve to the same visual style.
 */
export function EditorialText({
  as: Tag = "p",
  className = "",
  children,
  ...rest
}) {
  return (
    <Tag className={`editorial-copy ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
}

export default EditorialText;
